import { render, staticRenderFns } from "./AuthorityListProvider.vue?vue&type=template&id=db78b8d2&scoped=true&"
import script from "./AuthorityListProvider.vue?vue&type=script&lang=ts&"
export * from "./AuthorityListProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db78b8d2",
  null
  
)

export default component.exports